import * as React from 'react';
import { getBackgroundColorClass } from '@telia-front/colors';
const TableRow = (props) => {
    const { type, leftBorderColor, background, className, id, onClick, children } = props;
    const BEM = () => {
        const classArray = ['table__row'];
        if (type) {
            classArray.push('table__row--' + type);
        }
        if (leftBorderColor) {
            if (leftBorderColor === 'purple' || leftBorderColor === 'brand') {
                classArray.push('table__row--left-bordered-brand');
            }
            if (leftBorderColor === 'grey' || leftBorderColor === 'neutral-subtlest') {
                classArray.push('table__row--left-bordered-neutral-subtlest');
            }
            if (leftBorderColor === 'dark-grey' || leftBorderColor === 'neutral') {
                classArray.push('table__row--left-bordered-neutral');
            }
            if (leftBorderColor === 'info') {
                classArray.push('table__row--left-bordered-info');
            }
        }
        if (background && background !== 'transparent') {
            classArray.push(getBackgroundColorClass(background));
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("tr", { className: BEM(), id: id, onClick: onClick }, children));
};
export { TableRow as default };
